import React, { useState, useEffect } from "react";
import MonitoringBusinessAddressInfoForm from "./MonitoringBusinessAddressInfoForm";
import { CAProvinces, stateList } from "../../../../util/CommonLists";
import { MonitoringData } from "../../../../store/common";
import { useTranslation } from "react-i18next";

const MonitoringBusinessAddressInfo: React.FunctionComponent<{ monitoringData: MonitoringData; ensureDataFetch: any }> = (props) => {
    const [personalAssets, setPersonalAssets] = useState({});
    const [showForm, setShowForm] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [monitoringData, setMonitoringData] = useState(props.monitoringData);
    const { t: tLang } = useTranslation();

    const ensureDataFetched = () => {
        setisLoading(true);
        props.ensureDataFetch();
    };

    useEffect(() => {
        const dataAsset = props.monitoringData.asset;
        const addressInfo: any = dataAsset["addressInformation"];
        const personalInformation: any = dataAsset["personalInformation"];
        setPersonalAssets(personalInformation);
        setFormData({
            "ezshield-id": monitoringData && monitoringData["ezshield-id"] ? monitoringData["ezshield-id"] : "",
            "idf-user-id": monitoringData && monitoringData["idf-user-id"] ? monitoringData["idf-user-id"] : "",
            address1: addressInfo && addressInfo["address-street"] ? addressInfo["address-street"] : "",
            address2: addressInfo && addressInfo["address-street2"] ? addressInfo["address-street2"] : "",
            address3: addressInfo && addressInfo["address-street3"] ? addressInfo["address-street3"] : "",
            city: addressInfo && addressInfo && addressInfo["address-city"] ? addressInfo["address-city"] : "",
            state: addressInfo && addressInfo["address-state"] ? addressInfo["address-state"] : "",
            zipcode: addressInfo && addressInfo["address-code"] ? addressInfo["address-code"] : "",
            country: addressInfo && addressInfo["address-country"] ? addressInfo["address-country"] : "",
        });
        setisLoading(false);
    }, [props.monitoringData]);

    const [formData, setFormData] = useState({
        address1: "this is street",
        address2: "",
        address3: "",
        city: "Los angelas",
        state: "california",
        zipcode: 90262,
        "ezshield-id": "",
        "idf-user-id": "",
        country: "",
    });

    return (
        <div className={`box offset-padding ${isLoading && "loading"}`}>
            <div className="box-header">
                <div className="box-title-container">
                    <div className="box-title-icon" aria-hidden="true">
                        <em className="las la-map-marker"></em>
                    </div>
                    <div className="box-title-text has-actions">
                        <h2 className="box-title">{tLang("identityVault.monitoredInformation.businessAddressWidget.title")}</h2>
                    </div>
                </div>
                {!showForm && (
                    <div className="box-actions" onClick={() => setShowForm(true)}>
                        <button
                            type="button"
                            className="btn-default btn-grey-dot"
                            id="monitored-info-address"
                            onClick={() => window.addToDataLayer({ event: "Edit Address" })}
                        >
                            <span className="btn-text">
                                {tLang("identityVault.monitoredInformation.businessAddressWidget.editButtonText")}
                                <span className="sr-only">{tLang("identityVault.monitoredInformation.businessAddressWidget.title")}</span>
                            </span>
                            <span className="btn-icon">
                                <em className="las la-pen"></em>
                            </span>
                        </button>
                    </div>
                )}
            </div>
            <div className="box-content">
                {!showForm && (
                    <div role="grid" className="data-grid " id="monitored-info-address-grid" aria-hidden="false">
                        <div role="row" className="data-row row">
                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                <div className="data-label" id="label-street-display">
                                    {tLang("identityVault.monitoredInformation.businessAddressWidget.label.street")}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-street-display">
                                <div className="data-value">
                                    {formData.address1}
                                </div>
                            </div>
                        </div>
                        <div role="row" className="data-row row">
                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                <div className="data-label" id="label-street-display-1"></div>
                            </div>
                            <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-street-display-1">
                                <div className="data-value">
                                    {formData.address2}
                                </div>
                            </div>
                        </div>
                        <div role="row" className="data-row row">
                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                <div className="data-label" id="label-city-display">
                                    {tLang("identityVault.monitoredInformation.businessAddressWidget.label.city")}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-city-display">
                                <div className="data-value">
                                    {formData.city}
                                </div>
                            </div>
                        </div>

                        {["us", "united states of america", ""].indexOf(formData.country.toLowerCase()) >= 0 ? (
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-state-display">
                                        {tLang("identityVault.monitoredInformation.businessAddressWidget.label.state")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-state-display">
                                    <div className="data-value">
                                        {stateList.find((s) => s.value === formData.state)?.name}
                                    </div>
                                </div>
                            </div>
                        ) : formData.country === "CA" ? (
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-state-display">
                                        {tLang("identityVault.monitoredInformation.businessAddressWidget.label.province")}
                                    </div>
                                </div>
                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-state-display">
                                    <div className="data-value">
                                        {CAProvinces.find((s) => s.value === formData.state)?.name}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-state-display">
                                        {tLang("identityVault.monitoredInformation.businessAddressWidget.label.region")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-state-display">
                                    <div className="data-value">
                                        {formData.state}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div role="row" className="data-row row">
                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                <div className="data-label" id="label-zipcode-display">
                                    {["us", "united states of america", ""].indexOf(formData.country.toLowerCase()) >= 0
                                        ? tLang("identityVault.monitoredInformation.businessAddressWidget.label.zipcode")
                                        : tLang("identityVault.monitoredInformation.businessAddressWidget.label.postalCode")}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-zipcode-display">
                                <div className="data-value">
                                    {formData.zipcode}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showForm && (
                    <MonitoringBusinessAddressInfoForm
                        refreshDataCallback={ensureDataFetched}
                        setFormStatus={setShowForm}
                        personalInfo={personalAssets}
                        formData={formData}
                    />
                )}
            </div>
        </div>
    );
};

export default MonitoringBusinessAddressInfo;
